// extracted by mini-css-extract-plugin
export default {"picture":"Home_picture__x+SKb","headerText":"Home_headerText__fLLNO","introText":"Home_introText__OvMll"};